function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var _templateObject, _templateObject2, _templateObject3;
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
import "../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";
import { html as l } from "../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";
import "../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";
import { customElement as h } from "../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/decorators/custom-element.js";
import { property as u } from "../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/decorators/property.js";
import g from "../../packages/web-components/src/components/boolean/boolean.gator.scss.js";
import c from "../../packages/web-components/src/components/boolean/boolean.gator.tokens.scss.js";
import { generateRandomId as m, getElementId as f } from "../../utils/string-utils.js";
import "../radio-group/radio-group.gator.js";
import { NgcInputText as b } from "../input/gator/input-text/input-text.gator.js";
import { unsafeCSS as p } from "../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/css-tag.js";
var v = Object.defineProperty,
  _ = Object.getOwnPropertyDescriptor,
  $ = Object.getPrototypeOf,
  w = Reflect.get,
  d = function d(e, t, o, a) {
    for (var r = a > 1 ? void 0 : a ? _(t, o) : t, i = e.length - 1, n; i >= 0; i--) (n = e[i]) && (r = (a ? n(t, o, r) : n(r)) || r);
    return a && r && v(t, o, r), r;
  },
  y = function y(e, t, o) {
    return w($(e), o, t);
  };
var s = /*#__PURE__*/function (_b) {
  function s() {
    var _this;
    _classCallCheck(this, s);
    _this = _callSuper(this, s, arguments), _this.options = [], _this._randomId = m();
    return _this;
  }
  _inherits(s, _b);
  return _createClass(s, [{
    key: "firstUpdated",
    value: function firstUpdated() {
      var _this2 = this;
      this.handleResize(), window.addEventListener("resize", function () {
        return _this2.handleResize();
      });
    }
  }, {
    key: "render",
    value: function render() {
      return l(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\t\t<ngc-radio-group\n\t\t\t\tclass=", "\n\t\t\t\tid=", "\n\t\t\t\t.value=", "\n\t\t\t\t.disabled=", "\n\t\t\t\t.label=", "\n\t\t\t\thelp-text=", "\n\t\t\t\terror-text=", "\n\t\t\t\t@change=", "\n\t\t\t>\n\t\t\t\t", "\n\t\t\t</ngc-radio-group>"])), this.booleanClasses, this.elementId, this.value, this.disabled, this.label, this.helpText, this.errorText, this.handleChange, this.booleanOptions);
    }
  }, {
    key: "elementId",
    get: function get() {
      return f(this.id, this._randomId);
    }
  }, {
    key: "booleanClasses",
    get: function get() {
      var e = ["gator-boolean"];
      return this.isWrapped && e.push("gator-boolean_wrapped"), this.errorText && e.push("gator-boolean_error"), this.disabled && e.push("gator-boolean_disabled"), e.join(" ");
    }
  }, {
    key: "booleanOptions",
    get: function get() {
      var _this3 = this;
      if (!this.options) return null;
      var e = this.options.map(function (t, o) {
        return l(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\t\t<ngc-radio\n\t\t\t\t\tid=\"", "-option-", "\"\n\t\t\t\t\tclass=\"gator-boolean-option-", "", "\"\n\t\t\t\t\tvalue=", "\n\t\t\t\t\ttitle-text=", "\n\t\t\t\t></ngc-radio>\n\t\t\t"])), _this3.elementId, o, o, _this3.selectedClass(t), t.value, t.label);
      });
      return l(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), e);
    }
  }, {
    key: "isWrapped",
    get: function get() {
      var _this$shadowRoot;
      var e = (_this$shadowRoot = this.shadowRoot) === null || _this$shadowRoot === void 0 ? void 0 : _this$shadowRoot.querySelectorAll("ngc-radio");
      return e && e.length > 1 ? e[0].offsetTop < e[1].offsetTop : window.innerWidth < 475;
    }
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      var t = e;
      t.stopImmediatePropagation(), this.value = t.detail, this.dispatchEvent(new CustomEvent("change", {
        bubbles: !0,
        detail: this.value
      }));
    }
  }, {
    key: "handleResize",
    value: function handleResize() {
      var _this$shadowRoot2;
      var e = (_this$shadowRoot2 = this.shadowRoot) === null || _this$shadowRoot2 === void 0 ? void 0 : _this$shadowRoot2.querySelector("ngc-radio-group");
      this.isWrapped ? e === null || e === void 0 ? void 0 : e.classList.add("gator-boolean_wrapped") : e === null || e === void 0 ? void 0 : e.classList.remove("gator-boolean_wrapped");
    }
  }, {
    key: "selectedClass",
    value: function selectedClass(e) {
      return this.value === e.value ? " gator-boolean-option_selected" : "";
    }
  }]);
}(b);
s.styles = [].concat(_toConsumableArray(y(s, s, "styles")), [p(g), p(c)]);
d([u({
  type: Array
})], s.prototype, "options", 2);
s = d([h("ngc-boolean")], s);
export { s as NgcBoolean };